import { SharedPagedRequest } from "@sharedcommon/model/shared-page-request.model";

export class BusinessUnitFilterDto extends SharedPagedRequest {
  codes: string[];
  label: string;
  inCustomerCodes: string[];
}